module.exports = __webpack_public_path__ + "static/img/High Temperature Resistant Silicone Rubber.8d1e6e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/High Temperature Resistant Silicone Rubber.jpg
// module id = TDbU
// module chunks = 1